import { FaSuitcaseRolling } from "react-icons/fa";
import {
  HiOutlineClipboardDocumentCheck,
  HiOutlineCreditCard,
  HiOutlineCubeTransparent,
  HiOutlineIdentification,
  HiOutlineMagnifyingGlass,
  HiOutlinePaperAirplane,
  HiOutlineCheckCircle,
  HiOutlineShieldCheck,
  HiOutlineTicket,
} from "react-icons/hi2";

/**
 * מטא-דאטה ל-wizard — תואם ל־BOOKING_FLOW_STEP_ORDER (למעט שלבים מוסתרים לפי gate).
 */
export const FLIGHT_WIZARD_STEPS = [
  {
    id: "search",
    title: "חיפוש",
    shortTitle: "חיפוש",
    subtitle: "יעד, תאריכים, נוסעים והרצת חיפוש",
    Icon: HiOutlineMagnifyingGlass,
  },
  {
    id: "results",
    title: "תוצאות",
    shortTitle: "תוצאות",
    subtitle: "בחירת הצעה או מעבר להרכבת מסלול",
    Icon: HiOutlineTicket,
  },
  {
    id: "selfComposePick",
    title: "הרכבת מסלול",
    shortTitle: "הרכבה",
    subtitle: "הלוך וחזור מנפרד כשאין טיסת RT מוכנה",
    Icon: HiOutlineCubeTransparent,
  },
  {
    id: "flightDetails",
    title: "פירוט טיסה",
    shortTitle: "פירוט",
    subtitle: "מסלול נבחר, תמחור ופירוט לפני תוספות",
    Icon: HiOutlinePaperAirplane,
  },
  {
    id: "passengers",
    title: "נוסעים",
    shortTitle: "נוסעים",
    subtitle: "פרטי נוסעים ודרכונים",
    Icon: HiOutlineIdentification,
  },
  {
    id: "extras",
    title: "פרטים ובחירת כבודה",
    shortTitle: "שדרוגים",
    subtitle: "כבודה ושירותים — המחיר מתעדכן מיד בסיכום",
    Icon: FaSuitcaseRolling,
  },
  {
    id: "review",
    title: "סיכום הזמנה",
    shortTitle: "סיכום",
    subtitle: "הבקשה תישלח לספק — ללא חיוב בשלב זה",
    Icon: HiOutlineClipboardDocumentCheck,
  },
  {
    id: "holdConfirmation",
    title: "אישור החזקה",
    shortTitle: "החזקה",
    subtitle: "הטיסה מוחזקת — נדרש תשלום להשלמה",
    Icon: HiOutlineShieldCheck,
  },
  {
    id: "draftPayment",
    title: "טיוטה / תשלום",
    shortTitle: "תשלום",
    subtitle: "שמירה או המשך לתשלום",
    Icon: HiOutlineCreditCard,
  },
  {
    id: "success",
    title: "הצלחה",
    shortTitle: "סיום",
    subtitle: "אישור הזמנה והפניות הבאות",
    Icon: HiOutlineCheckCircle,
  },
];

export function getVisibleFlightWizardSteps(searchGate) {
  const showSelfCompose =
    searchGate?.needsSelfComposePickStep || searchGate?.allowSelfComposeChoice;
  const withoutPassengers = FLIGHT_WIZARD_STEPS.filter((s) => s.id !== "passengers");
  if (!showSelfCompose) {
    return withoutPassengers.filter((s) => s.id !== "selfComposePick");
  }
  return withoutPassengers;
}

export function getFlightWizardStepMeta(stepId) {
  return FLIGHT_WIZARD_STEPS.find((s) => s.id === stepId) ?? FLIGHT_WIZARD_STEPS[0];
}
